import React from 'react'

import { Trans, useTranslation } from 'react-i18next'

import LinkButton from '@components/shared/LinkButton'
import EduPricing from '@features/compare-plans/EduPlanCard/EduPricing'
import FeatureExpander from '@features/compare-plans/FeatureExpander'
import FeatureList from '@features/compare-plans/FeatureList'
import { FEATURES } from '@features/compare-plans/FeatureList/constants'
import PlanCard from '@features/compare-plans/PlanCard'
import { getDollarsAndCentsFromPrice } from '@utils/formatters/number.formatter'
import PageRoutes from '@utils/page-routes'

import type { EduPricingResponse } from '@pages/plans/plans.loader'

interface Props {
  eduPricing: EduPricingResponse
}

const EduPlanCard: React.FC<Props> = ({ eduPricing }) => {
  const { t } = useTranslation()
  const learnYearly = getDollarsAndCentsFromPrice(eduPricing.learn_price)
  return (
    <PlanCard
      planType="edu"
      description={
        <Trans
          i18nKey="plans.edu.description"
          components={[<span className="font-semibold" key="0" />]}
        />
      }
      pricing={<EduPricing yearlyPrice={learnYearly.dollars} minUsers={eduPricing.min_users} />}
      className="border-t-4 py-5 border-green">
      <LinkButton
        href={PageRoutes.purchaseLearn()}
        external
        variant="edu"
        className="mb-1 w-full font-medium"
        size="lg">
        {t('plans.edu.action')}
      </LinkButton>
      <a
        href={PageRoutes.learnTrialPath()}
        className="w-full p-2 text-center underline"
        title="learn trial">
        {t('plans.edu.trial')}
      </a>

      <FeatureExpander learnStyling>
        <FeatureList features={FEATURES.edu} />
        <LinkButton
          href={PageRoutes.learnPath()}
          external
          variant="outline"
          className="mt-5 w-full font-medium"
          size="lg">
          {t('action.learnMore')}
        </LinkButton>
      </FeatureExpander>
    </PlanCard>
  )
}

export default EduPlanCard
